import { createSelector } from 'reselect';
import { MetadataConstants, MetadataSelectors } from 'invision-core';
var CATEGORY_CODE = 0;
export var IsLoadedSelector = createSelector([MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ProductFacet), MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ProductFacetCategory)], function (facetLoaded, facetCategoryLoaded) {
  return facetCategoryLoaded && facetLoaded;
});
export var ProductFacetsSelector = createSelector([MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.ProductFacet), MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.ProductFacetCategory)], function (productFacets, facetCategories) {
  var facets = [];
  facetCategories.forEach(function (facet) {
    facets.push({
      name: facet.Name,
      value: facet.Value,
      subFacets: []
    });
  });
  productFacets.forEach(function (subFacet) {
    var foundFacet = facets.find(function (facet) {
      return facet.value === subFacet.AdditionalProperties[CATEGORY_CODE].Value;
    });
    if (foundFacet) {
      foundFacet.subFacets.push(subFacet);
    }
  });
  return facets;
});
export var ProductCategoriesSelector = createSelector([MetadataSelectors.categories.CategoriesDataSelector], function (categories) {
  if (categories) {
    return categories.asMutable({
      deep: true
    });
  }
});